import BaseStore from "@/v1/utils/BaseStore";

import { GET_CREDENTIALS_START, GET_CREDENTIALS_SUCCESS } from "./types";

const initialState = {
  credentials: {
    loading: false,
    results: [],
  },
  configurations: {
    loading: false,
    results: [],
  },
  integrationSetups: {
    loading: false,
    results: {},
  },
  integrationSetupsConfigurations: {
    loading: false,
    results: [],
  },
  integrationSetupDetail: {
    loading: false,
    id: null,
    jurisdiction: { id: null },
    integrator: { id: null },
    software: { id: null },
    integratorSetup: { id: null },
    attributeCollection: { id: null },
  },
};

const store = new BaseStore("environments", initialState);

const reducer = {
  [GET_CREDENTIALS_START]: (state) => ({
    ...state,
    credentials: {
      ...state.credentials,
      loading: true,
    },
  }),
  [GET_CREDENTIALS_SUCCESS]: (state, payload) => ({
    ...state,
    credentials: {
      ...state.credentials,
      ...payload.credentials,
      loading: false,
    },
  }),
};

export default store.reducer(reducer);
